module.exports = __webpack_public_path__ + "img/126.18f8f3f8.webp";